module.exports = __webpack_public_path__ + "img/Carousel-Beneficios-icono-06.491d6ca5.svg";